// extracted by css-extract-rspack-plugin
export default {"container":"container-RbRjeH","canvas":"canvas-E34VKe"};